import { toUnicode } from "punycode";
import { regexTextPunycode } from "./";
export const textCapitalize = (text) => `${text[0].toUpperCase()}${text.slice(1)}`;
export const textCurrencySymbolGet = (currency) => {
    if (currency === "EUR")
        return "€";
    if (currency === "RUB")
        return "₽";
    if (currency === "USD")
        return "$";
    return currency;
};
export const textHasWhitespace = (text) => /\s/g.test(text);
export const textIsPunycode = (text) => regexTextPunycode.test(text);
export const textMatch = (needle, haystack) => {
    const n = needle.toLowerCase();
    const h = haystack.toLowerCase();
    const hlen = h.length;
    const nlen = n.length;
    if (nlen > hlen) {
        return false;
    }
    if (n === h) {
        return n === h;
    }
    outer: for (var i = 0, j = 0; i < nlen; i++) {
        var nch = n.charCodeAt(i);
        while (j < hlen) {
            if (h.charCodeAt(j++) === nch) {
                continue outer;
            }
        }
        return false;
    }
    return true;
};
export const searchInText = (searchValue, text) => text.toLowerCase().includes(searchValue.toLowerCase());
export const textPunycodeToUnicode = (punycode) => {
    try {
        return toUnicode(punycode);
    }
    catch (error) {
        return punycode;
    }
};
export const truncateByMiddle = (string, maxLength, separator) => {
    if (!string)
        return;
    maxLength = maxLength || 10;
    const stringLength = string.length;
    if (stringLength > maxLength) {
        separator = separator || "...";
        const separatorLength = separator.length;
        if (separatorLength > maxLength) {
            return string.substring(stringLength - maxLength);
        }
        const n = -0.5 * (maxLength - stringLength - separatorLength);
        const center = stringLength / 2;
        const front = string.substring(0, center - n);
        const back = string.substring(stringLength - center + n);
        return front + separator + back;
    }
    return string;
};
export const reduceBreakLines = (input) => input.replace(/\n{2,}/g, (match) => "\n".repeat(match.length - 1));
export const increaseBreakLines = (input) => input.replace(/\n+/g, (match) => "\n".repeat(match.length + 1));
export const textTemplateRender = (template, data) => {
    // Убираем однострочные комментарии {{! ... }}
    template = template.replace(/{{!\s*.*?\s*}}/g, "");
    // Убираем блочные комментарии {{!-- ... --}}
    template = template.replace(/{{!--[\s\S]*?--}}/g, "");
    // Поддержка {{each array}} ... {{/each}}
    template = template.replace(/{{each (\w+)}}([\s\S]*?){{\/each}}/g, (_, arrName, inner) => {
        const arr = data[arrName] || [];
        return arr
            .map((item) => textTemplateRender(inner, Object.assign(Object.assign({}, data), { this: item })))
            .join("");
    });
    // Поддержка {{if condition}} ... {{/if}}
    template = template.replace(/{{if (\w+)}}([\s\S]*?){{\/if}}/g, (_, cond, inner) => data[cond] ? textTemplateRender(inner, data) : "");
    // Подстановка значений {{key}}
    template = template.replace(/{{(\w+)}}/g, (match, key) => { var _a; return (_a = data[key]) !== null && _a !== void 0 ? _a : match; });
    return template
        .split("\n")
        .map((line) => line.trimEnd())
        .filter((line, idx, arr) => {
        if (line.trim() !== "") {
            return true;
        }
        if (idx === 0 || idx === arr.length - 1) {
            return false;
        }
        return true;
    })
        .join("\n")
        .trim();
};
export const parseJsonBlock = (source) => {
    if (typeof source === "object") {
        return source;
    }
    const match = source.match(/```json([\s\S]*?)```/);
    const str = (match === null || match === void 0 ? void 0 : match.at(1)) ? match[1].trim() : source.trim();
    try {
        return JSON.parse(str);
    }
    catch (e) {
        console.error("ParseJsonBlock error", e);
        return null;
    }
};
//# sourceMappingURL=text.js.map